// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  margin-top: inherit;
  margin-bottom: inherit;
}

.btnIcon {
  text-align: center;
}

.address {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 7px;
  margin: 1%;
  background-color: #f5f5f5;
  align-items: center;
  border-radius: 15px;
}

.icon-overlayDel {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

ion-searchbar {
  --box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  --border-radius: 15px ;
}

ion-content {
  --ion-background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/address/list-address-selectable/list-address-selectable.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,sCAAA;AACJ;;AAEA;EACI,6CAAA;EACA,sBAAA;AACJ;;AAEA;EACI,wCAAA;AACJ","sourcesContent":["p {\r\n    margin-top: inherit;\r\n    margin-bottom: inherit;\r\n}\r\n\r\n.btnIcon {\r\n    text-align: center;\r\n}\r\n\r\n.address {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-around;\r\n    padding: 7px;\r\n    margin: 1%;\r\n    background-color: #f5f5f5;\r\n    align-items: center;\r\n    border-radius: 15px;\r\n}\r\n\r\n.icon-overlayDel {\r\n    width: 1.5rem;\r\n    height: 1.5rem;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\nion-searchbar {\r\n    --box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n    --border-radius: 15px\r\n}\r\n\r\nion-content{\r\n    --ion-background-color: white !important; \r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
